export const sensitiveWords = [
    ['TMD', 'tmd'],
    ['他妈的', '他妈'],
    ['草泥马', 'cnm', '草你妈'],
    ['NMSL', 'nmsl'],
    ['反弹'],
    ['傻X', '傻x', '傻逼', 'SB', 'sb', '臭傻逼'],
    ['憨豆'],
    ['神经病'],
    ['脑子有病', '脑子'],
    ['爱买不买', '穷鬼', '事多', '难伺候', '故意找茬'],
    ['没家教的东西', '没家教'],
    ['你是人？'],
    ['听不明白人话 去学OK？', '人话'],
    ['亲亲 这边补偿您1000元冥币您看可以吗', '冥币'],
    ['天打雷劈你'],
    ['huiqi'],
    ['你全家死干净了', '死全家'],
    ['诅咒你全家'],
    ['你全家出去买电池被车撞死', '被车撞死'],
    ['死了吗？'],
    ['办丧事去了吗？', '丧事'],
    ['厉害你妈', '你妈'],
    ['王八蛋'],
    ['去死吧你', '去死'],
    ['滚吧'],
    ['恶心'],
    ['说人话'],
    ['求我？跪下'],
    ['你爹出车祸了？', '你爹'],
    ['畜生东西', '畜生'],
    ['出生东西']
];

export function isSensitiveWords(words: string) {
    const allWords = sensitiveWords.flat();
    // 判断是否包含敏感词
    for (const word of allWords) {
        if (words.includes(word)) {
            return word;
        }
    }
    return false;
}
